export default [
    {
      key: 'name',
      label: 'field.requestSectionName',
      type: 'text',
      operator: '%',
    },
  ];
  